/* Amryth cart drawer: instant in-cart edits.
   The theme's cart.js flow (300ms debounce → fetch → full drawer re-render, pointer-events locked meanwhile) is bypassed
   for quantity/remove inside the drawer. We update the DOM immediately, coalesce edits, send ONE /cart/update.js
   (line-position array), then reconcile numbers from the JSON response. No HTML re-render, no lock. */
(function () {
  'use strict';
  var timer = null, inflight = false, dirty = false;
  function money(c) { var v = (c / 100).toFixed(2); return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function drawer() { return document.querySelector('cart-drawer'); }
  function items(d) { return [].slice.call(d.querySelectorAll('#CartDrawer-CartItems .am-cart__item')); }
  function qty(it) { return parseInt(it.dataset.lineQty, 10) || 0; }

  function recalc() {
    var d = drawer(); if (!d) return;
    var units = 0, total = 0;
    items(d).forEach(function (i) { units += qty(i); total += qty(i) ? (parseInt(i.dataset.linePrice, 10) || 0) : 0; });
    // Order-level (cart) discounts, e.g. a 20% promo code, scale the optimistic total until the server footer lands.
    var ratio = parseFloat(d.dataset.orderRatio) || 0; if (ratio > 0 && ratio < 1) total = Math.round(total * (1 - ratio));
    var count = d.querySelector('.am-cart__count'); if (count) count.textContent = units;
    d.querySelectorAll('.am-cart__totals b').forEach(function (n) { n.textContent = money(total); });
    d.querySelectorAll('.am-cart__checkout-total').forEach(function (n) { n.textContent = '| ' + money(total); });
    d.classList.toggle('is-empty', units === 0);
    var cdi = d.querySelector('cart-drawer-items'); if (cdi) cdi.classList.toggle('is-empty', units === 0);
    var u = d.querySelector('.am-cart__unlock'); if (!u) return;
    var per = parseInt(u.dataset.cansPerUnit, 10) || 4, cans = units * per;
    var anySub = items(d).some(function (i) { return qty(i) && i.dataset.plan; });
    var tierSrc = anySub ? (u.dataset.tiersSub || u.dataset.tiers) : (u.dataset.tiersOnetime || u.dataset.tiers);
    var tiers = (tierSrc || '').split('|').map(function (t) { var p = t.split('='); return { cans: parseInt(p[0], 10) || 0, pct: parseInt(p[1], 10) || 0 }; }).filter(function (t) { return t.cans > 0; });
    var max = tiers.reduce(function (m, t) { return Math.max(m, t.cans); }, 0);
    var fill = u.querySelector('.am-cart__bar-fill'); if (fill && max) fill.style.width = Math.min(100, cans / max * 100) + '%';
    var next = null, unlocked = 0;
    tiers.forEach(function (t) { if (cans >= t.cans) unlocked = t.pct; else if (!next) next = t; });
    u.querySelectorAll('.am-cart__tick').forEach(function (tk, i) { if (tiers[i]) tk.classList.toggle('is-hit', cans >= tiers[i].cans); });
    var txt = u.querySelector('.am-cart__unlock-text');
    if (txt) {
      if (next) { var r = next.cans - cans; txt.innerHTML = 'Add <b>' + r + (cans > 0 ? ' more' : '') + ' can' + (r !== 1 ? 's' : '') + '</b> to unlock <b>' + next.pct + '% off</b>'; }
      else txt.innerHTML = '<b>' + unlocked + '% off unlocked.</b> That’s our best price.';
    }
  }

  function setLine(it, q, price, orig) {
    it.dataset.lineQty = q; it.dataset.linePrice = price;
    var b = it.querySelector('.am-cart__price b'); if (b) b.textContent = money(price);
    var s = it.querySelector('.am-cart__price s');
    if (s) { if (orig != null && orig !== price) { s.textContent = money(orig); s.style.display = ''; } else s.style.display = 'none'; }
    var inp = it.querySelector('.quantity__input'); if (inp && parseInt(inp.value, 10) !== q) inp.value = q;
    var meta = it.querySelector('.am-cart__meta'); if (meta && /^\d+\s*×/.test(meta.textContent.trim())) meta.textContent = meta.textContent.replace(/^\s*\d+/, q);
    it.classList.toggle('is-removing', q === 0);
  }

  function reindex(d) {
    items(d).forEach(function (it, i) {
      var n = i + 1;
      it.id = 'CartDrawer-Item-' + n;
      it.querySelectorAll('[data-index]').forEach(function (el) { el.dataset.index = n; });
      var inp = it.querySelector('.quantity__input'); if (inp) inp.id = 'Drawer-quantity-' + n;
      var rb = it.querySelector('cart-remove-button'); if (rb) rb.id = 'CartDrawer-Remove-' + n;
      var er = it.querySelector('.cart-item__error'); if (er) er.id = 'CartDrawer-LineItemError-' + n;
    });
  }

  function schedule() { dirty = true; clearTimeout(timer); timer = setTimeout(sync, 200); }

  function sync() {
    if (inflight) return;
    var d = drawer(); if (!d) return;
    var updates = items(d).map(qty);
    if (!updates.length) { dirty = false; refresh(d); return; }
    dirty = false; inflight = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (cart) { if (!dirty) reconcile(d, cart); })
      .catch(function () { refresh(d); })
      .then(function () { inflight = false; if (dirty) sync(); });
  }

  // Server truth → DOM. Lines are matched by POSITION (Shopify keeps line order; Stoq re-creates lines on every change, so keys are not stable).
  function reconcile(d, cart) {
    var dom = items(d), srv = cart.items || [];
    if (dom.length !== srv.length) { refresh(d); return; }
    dom.forEach(function (it, i) {
      var ci = srv[i];
      if (String(ci.variant_id) !== String(it.dataset.variantId)) { it.dataset.mismatch = '1'; }
      it.dataset.key = ci.key;
      setLine(it, ci.quantity, ci.final_line_price, ci.original_line_price);
      var inp = it.querySelector('.quantity__input'); if (inp) inp.setAttribute('value', ci.quantity);
    });
    if (dom.some(function (it) { return it.dataset.mismatch; })) { refresh(d); return; }
    var lines = srv.reduce(function (s, i) { return s + (i.final_line_price || 0); }, 0);
    var cl = (cart.cart_level_discount_applications || []).reduce(function (s, a) { return s + (a.total_allocated_amount || 0); }, 0);
    d.dataset.orderRatio = lines ? (cl / lines) : 0;
    reindex(d); recalc();
    if (cart.sections && cart.sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var doc = new DOMParser().parseFromString(cart.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (bubble && doc) bubble.innerHTML = doc.innerHTML;
    }
    if (cart.sections && cart.sections['cart-drawer']) {
      var srcFooter = new DOMParser().parseFromString(cart.sections['cart-drawer'], 'text/html').querySelector('.drawer__footer');
      var dstFooter = d.querySelector('.drawer__footer');
      if (srcFooter && dstFooter) dstFooter.innerHTML = srcFooter.innerHTML;
    }
    dedupeCheckout(d);
    document.dispatchEvent(new CustomEvent('amryth:cart', { detail: cart }));
  }

  // SavedBy rewrites the checkout button label with its own total; never show two prices.
  function dedupeCheckout(d) {
    d.querySelectorAll('#CartDrawer-Checkout').forEach(function (btn) {
      var label = btn.querySelector('span:not(.am-cart__checkout-total)'), total = btn.querySelector('.am-cart__checkout-total');
      if (!label || !total) return;
      var hasPrice = /\$\s?\d/.test(label.textContent);
      if (total.hidden !== hasPrice) total.hidden = hasPrice;
    });
    styleSavedBy(d);
  }
  var moBusy = false;
  var mo = new MutationObserver(function () { if (moBusy) return; moBusy = true; try { var d = drawer(); if (d) dedupeCheckout(d); } finally { moBusy = false; } });
  function armObserver() { var d = drawer(); if (d) { mo.observe(d, { subtree: true, childList: true, characterData: true }); dedupeCheckout(d); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armObserver); else armObserver();

  // SavedBy renders its protection row + "Continue without protection" inside an open shadow root: restyle it Brez-style (underlined link, plain row).
  var SB_CSS = '.sb__parent{font-family:"Manrope",sans-serif!important;color:#14121F}' +
    '.sb__info-wrapper{background:transparent!important;border:0!important;border-top:1px solid #E3E1F0;padding:12px 0 14px!important;margin:0!important;border-radius:0!important}' +
    '.sb__info-container{padding:0!important;gap:10px!important}' +
    '.sb__info-logo-container img{width:22px!important;height:22px!important}' +
    '.sb__info-text-container{font-size:14px!important;font-weight:700!important;color:#14121F!important}' +
    '.sb__info-text-container [name=description]{font-weight:500!important;font-size:13px!important;color:#4E4B63!important}' +
    '.sb__info-text-container [name=fee]{font-weight:600!important;color:#14121F!important}' +
    '.sb__info-help-button{opacity:.6}.sb__info-help-button svg{width:18px!important;height:18px!important}' +
    '.sb__checkout-wrapper,.sb__checkout-container{padding:0!important;margin:0!important;background:transparent!important}' +
    '.sb__continue-container{text-align:center!important;padding:14px 0 0!important;margin:0!important}' +
    '.sb__non-covered-link{display:inline!important;border:0!important;background:transparent!important;padding:0!important;font:600 14px "Manrope",sans-serif!important;color:#14121F!important;text-decoration:underline!important;text-underline-offset:3px!important;cursor:pointer;text-transform:none!important;letter-spacing:0!important;width:auto!important;border-radius:0!important;box-shadow:none!important}';
  function styleSavedBy(d) {
    (d || document).querySelectorAll('savedby-checkout-plus').forEach(function (el) {
      var sr = el.shadowRoot; if (!sr || sr.querySelector('#am-sb-style')) return;
      var st = document.createElement('style'); st.id = 'am-sb-style'; st.textContent = SB_CSS; sr.appendChild(st);
    });
  }
  // SavedBy attaches/re-renders its shadow root after inserting the element (no light-DOM mutation to observe): keep checking.
  setInterval(function () { styleSavedBy(document); }, 700);

  // Fallback: full section re-render (same thing the theme does)
  function refresh(d) {
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
        var dst = d.querySelector('.drawer__inner');
        if (src && dst) { dst.innerHTML = src.innerHTML; recalc(); dedupeCheckout(d); }
      }).catch(function () {});
  }

  // Stepper / typed quantity: intercept before the theme's handlers see it.
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('cart-drawer .quantity__input')) return;
    var it = inp.closest('.am-cart__item'); if (!it) return;
    e.stopPropagation();
    var oldQ = qty(it) || 1, oldP = parseInt(it.dataset.linePrice, 10) || 0;
    var q = Math.max(0, parseInt(inp.value, 10) || 0);
    setLine(it, q, Math.round((oldP / oldQ) * q));
    recalc(); schedule();
  }, true);

  // Remove
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('cart-drawer .am-cart__remove') : null;
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var it = btn.closest('.am-cart__item'); if (!it) return;
    setLine(it, 0, 0);
    recalc(); schedule();
  }, true);

  // Upgrade to subscription / switch to one-time: change the line's selling plan, then re-render from the server.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('cart-drawer .am-cart__upgrade, cart-drawer .am-cart__switch') : null;
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var d = drawer(); if (!d || btn.disabled) return;
    var it = btn.closest('.am-cart__item'); var line = it ? items(d).indexOf(it) + 1 : parseInt(btn.dataset.line, 10);
    var q = it ? qty(it) : parseInt(btn.dataset.qty, 10);
    var label = btn.textContent; btn.disabled = true; btn.textContent = btn.classList.contains('am-cart__upgrade') ? 'Upgrading…' : 'Switching…';
    var body = { line: line, quantity: q || 1, selling_plan: btn.dataset.plan ? btn.dataset.plan : null };
    var run = function () {
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function () { return refresh(d); })
        .catch(function () { btn.disabled = false; btn.textContent = label; });
    };
    // wait for any in-flight quantity sync first so the line index is right
    var wait = function () { return inflight || dirty ? new Promise(function (ok) { setTimeout(ok, 150); }).then(wait) : Promise.resolve(); };
    wait().then(run);
  }, true);

  // Empty-cart packs: add N of the variant, then re-render the drawer + header bubble.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('cart-drawer .am-cart__pack-add') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var d = drawer(); if (!d) return;
    btn.disabled = true; var label = btn.textContent; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variant, 10), quantity: parseInt(btn.dataset.qty, 10) || 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () { d.classList.remove('is-empty'); return refresh(d); })
      .then(function () { return fetch(window.location.pathname + '?section_id=cart-icon-bubble').then(function (r) { return r.text(); }).then(function (html) { var b = document.getElementById('cart-icon-bubble'); var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section'); if (b && src) b.innerHTML = src.innerHTML; }); })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  }, true);

  window.AmCart = { recalc: recalc, sync: sync };
})();
